export const EXTERNAL_OPTIONS_PHASE_1_GATE = 'FDG:XOv3:Phase1';